import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { Row, Col, Label, } from "reactstrap"
import { FormControl, TextField } from "@mui/material"
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment"
import moment from "moment"


const CustomeFilterForDate_by_order = ({ handleDateChange, from, to }) => {

    return (<>
        <Col md={6} xl={6} xs={6} sm={6} lg={6}>
            <FormControl className="w-100 mb-2 ">
                <Label for="fromDate">FROM</Label>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                        slotProps={{ textField: { variant: 'standard' } }}
                        onChange={(date) => handleDateChange(date, 'from_order_date')}
                        name='from_order_date'
                        id="from_order_date"
                        value={from ? moment(from):null}
                        renderInput={(params) => <TextField {...params} />}
                        fullWidth
                        leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
                        rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
                        format="DD/MM/YYYY"
                    />
                </LocalizationProvider>
            </FormControl>
        </Col>

        <Col md={6} xl={6} xs={6} sm={6} lg={6}>
            <FormControl >
                <Label for="toDate">TO</Label>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                        slotProps={{ textField: { variant: 'standard' } }}
                        type="date"
                        variant="standard"
                        onChange={(date) => handleDateChange(date, 'to_order_date')}
                        name='to_order_date'
                        id="to_order_date"
                        value={to? moment(to):null}
                        fullWidth
                        leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
                        rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
                        format="DD/MM/YYYY"
                    />
                </LocalizationProvider>
            </FormControl>
        </Col>

    </>)
}

export default CustomeFilterForDate_by_order